import React from "react";
import { Box, Paper } from "@material-ui/core";
import EnhancedDropdownComponent from "../../../../Common/Dropdowns/EnhancedDropdownComponent";
import CheckboxComponent from "../../../../Common/Checkboxes/CheckboxComponent";
import ModifiedByInfo from "../../../../Common/Footers/ModifiedByInfo";
import { LanguagesWithLanguageCode } from "../../../../../utils/constants";
import {
	getObjectTypeOptions,
	getMessageTypeOptions,
	getBrandOptions,
	getUseCaseOptions,
} from "../utils/optionFormatters";
import MessageBodyEditor from "./MessageBodyEditor";

const MessageTemplateForm = ({
	resources,
	formData,
	brands,
	useCases,
	formattedOutlets,
	loadingStates,
	templateId,
	errors,
	handleObjectTypeChange,
	handleMessageTypeChange,
	handleUseCaseChange,
	handleBrandChange,
	handleLanguageChange,
	handleOutletChange,
	handleIsWaitsOnPremiseDependentChange,
	handleIsWaitsOnPremiseChange,
	handleBodyChange,
	dealerGroupId,
	markPreviewAsViewed,
	showPreview,
}) => {
	const objectTypeOptions = getObjectTypeOptions(resources);
	const messageTypeOptions = getMessageTypeOptions(resources);
	const brandOptions = getBrandOptions(brands, resources);
	const useCaseOptions = getUseCaseOptions(useCases);

	const showError = (fieldName) => errors[fieldName];

	const isEditMode = Boolean(templateId);

	return (
		<div className="container">
			<div className="py-4">
				<Paper elevation={3} className="p-4 mt-3 mb-3">
					<Box className="d-flex flex-column align-items-center">
						<div style={{ maxWidth: "800px", width: "100%" }}>
							<EnhancedDropdownComponent
								value={formData.objectType}
								options={objectTypeOptions}
								labelText={resources["ObjectTypeLabel"]}
								id="object-type-dropdown"
								placeholder={resources["SelectObjectType"]}
								handleChange={handleObjectTypeChange}
								disabled={isEditMode || loadingStates.objectTypeChange}
							/>

							<EnhancedDropdownComponent
								value={formData.messageType}
								options={messageTypeOptions}
								labelText={resources["MessageType"]}
								id="message-type-dropdown"
								placeholder={resources["SelectMessageType"]}
								handleChange={handleMessageTypeChange}
								disabled={
									isEditMode ||
									loadingStates.objectTypeChange ||
									loadingStates.messageTypeChange
								}
							/>

							<EnhancedDropdownComponent
								value={formData.useCase?.id || 0}
								options={useCaseOptions}
								labelText={resources["UseCaseDescription"]}
								id="use-case-dropdown"
								handleChange={handleUseCaseChange}
								error={showError("useCase")}
								helperText={resources["FieldRequired"]}
								required
								placeholder={resources["Select"]}
								disabled={
									isEditMode ||
									loadingStates.objectTypeChange ||
									loadingStates.messageTypeChange
								}
							/>

							<EnhancedDropdownComponent
								value={formData.language}
								options={LanguagesWithLanguageCode.map((lang) => ({
									key: lang.code,
									name: lang.Name,
								}))}
								labelText={resources["Language"]}
								id="language-dropdown"
								handleChange={handleLanguageChange}
								error={showError("language")}
								helperText={
									showError("language") ? resources["FieldRequired"] : ""
								}
								disabled={isEditMode}
							/>

							<EnhancedDropdownComponent
								value={formData.outletId || 0}
								options={formattedOutlets}
								labelText={resources["Outlet"]}
								id="outlet-dropdown"
								placeholder={resources["All"]}
								handleChange={handleOutletChange}
								disabled={isEditMode}
							/>

							<EnhancedDropdownComponent
								value={formData.brand.id || 0}
								options={brandOptions}
								labelText={resources["Brand"]}
								id="brand-dropdown"
								handleChange={handleBrandChange}
								disabled={isEditMode || loadingStates.objectTypeChange}
							/>

							<CheckboxComponent
								label={resources["IsWaitsOnPremiseDependent"]}
								id="isWaitsOnPremiseDependent"
								checked={formData.isWaitsOnPremiseDependent}
								onChange={handleIsWaitsOnPremiseDependentChange}
							/>

							<CheckboxComponent
								label={resources["IsWaitsOnPremise"]}
								id="isWaitsOnPremise"
								checked={formData.isWaitsOnPremise}
								onChange={handleIsWaitsOnPremiseChange}
								disabled={!formData.isWaitsOnPremiseDependent}
							/>

							<MessageBodyEditor
								messageType={formData.messageType}
								value={formData.body}
								onChange={handleBodyChange}
								resources={resources}
								error={showError("body")}
								disabled={
									loadingStates.objectTypeChange ||
									loadingStates.messageTypeChange
								}
								dealerGroupId={dealerGroupId}
								markPreviewAsViewed={markPreviewAsViewed}
								showPreview={showPreview}
								useCase={formData.useCase}
							/>
						</div>
					</Box>

					{isEditMode && formData.modified.on !== "" && (
						<ModifiedByInfo
							className="mt-5"
							resources={resources}
							modifiedByAvatar={formData.modified.avatar}
							modifiedOn={formData.modified.on}
							modifiedByName={`${formData.modified.byFirstName} ${formData.modified.byLastName}`}
							localeDate={true}
						/>
					)}
				</Paper>
			</div>
		</div>
	);
};

export default MessageTemplateForm;
